import React from 'react'

function Error() {
    return (
        <div className='section section-center text-center page-100'>
            <h2>there was an error...</h2>
        </div>
    )
}

export default Error